export default "__VITE_ASSET__BvtqFcV4__"